import React from 'react';
import { ST_CONNECTIONS } from '../../growth-settings/mockData';
import type { StConnectionItem } from '../../growth-settings/types';
import { StFlatPanel, StSectionCard } from './SettingsPrimitives';

export interface SettingsConnectionsProps {
  connections?: StConnectionItem[];
  onConnect?: (provider: string) => void;
  onDisconnect?: (provider: string) => void;
}

export function SettingsConnections({
  connections = ST_CONNECTIONS,
  onConnect,
  onDisconnect,
}: SettingsConnectionsProps) {
  return (
    <StSectionCard
      title="Connections"
      description="Connect your accounts so ELVA can optimize campaigns and track outcomes end-to-end."
    >
      <StFlatPanel>
        {connections.map((item) => {
          const provider = item.provider ?? item.id;
          const connected = item.status === 'connected';
          return (
            <div
              key={item.id}
              className="flex flex-wrap items-center justify-between gap-3 border-b border-[var(--cream-2)] py-3 last:border-b-0"
            >
              <div className="min-w-0">
                <p className="text-[13.5px] font-semibold text-[var(--ink-1)]">{item.title}</p>
                <p className="mt-1 text-[13px] text-[var(--ink-3)]">{item.detail}</p>
              </div>
              <button
                type="button"
                onClick={() =>
                  connected ? onDisconnect?.(provider) : onConnect?.(provider)
                }
                className={
                  connected
                    ? 'inline-flex h-9 cursor-pointer items-center rounded-[var(--r-sm)] border border-[var(--cream-2)] bg-[var(--cream-1)] px-4 text-[13px] font-medium text-[var(--ink-2)]'
                    : 'inline-flex h-9 cursor-pointer items-center rounded-[var(--r-sm)] border border-[var(--success)] bg-[var(--success)] px-4 text-[13px] font-medium text-[var(--cream-1)]'
                }
              >
                {connected ? 'Disconnect' : 'Connect'}
              </button>
            </div>
          );
        })}
      </StFlatPanel>
    </StSectionCard>
  );
}
